const mutations = {
  updateAuthStatus(state, status) {
    state.authenticated = status;
  },
  updateLoggedInUser(state, user) {
    state.loggedInUser = user;
  },
  setUserList(state, data) {
    state.userList = data;
  },
  setCustomerList(state, data) {
    state.customerList = data;
  },
  setUser(state, data) {
    state.user = data;
  },
  setUserRole(state, role) {
    state.user.roleId = role;
  },
  setUserQuotations(state, payload) {
    state.userQuotations = payload;
  },
  setUserQuotationMeta(state, payload) {
    state.userQuotationMeta = payload;
  },

  resetUser(state) {
    state.user = {
      firstName: "",
      lastName: "",
      roleId: "",
      gender: "male",
      phone: "",
      email: "",
      age: "",
      preferredProductPriceType: "Retail",
      customerTypes: "person",
      creditLimit: 0,
      metaData: {
        gstNumber: "",
        societyName: "",
        societyInformation: [
          {
            label: "Chairman Name"
          },
          {
            label: "Secretary Name"
          },
          {
            label: "Manager Name"
          }
        ],
        firmInformation: [
          {
            label: "Owner"
          },
          {
            label: "Manager"
          }
        ]
      },
      firstNameMarathi: "",
      lastNameMarathi: "",
      addresses: [{ address: "", addressMarathi: "" }]
    };
  },
  prefillUser(state, data) {
    state.user = {
      firstName: data.name ? data.name : "",
      lastName: "",
      roleId: "",
      gender: "male",
      phone: data.phone ? data.phone : "",
      email: "",
      age: "",
      preferredProductPriceType: "Retail",
      customerTypes: "person",
      creditLimit: 0,
      metaData: {
        gstNumber: "",
        societyName: "",
        societyInformation: [
          {
            label: "Chairman Name"
          },
          {
            label: "Secretary Name"
          },
          {
            label: "Manager Name"
          }
        ],
        firmInformation: [
          {
            label: "Owner"
          },
          {
            label: "Manager"
          }
        ]
      },
      firstNameMarathi: "",
      lastNameMarathi: "",
      addresses: [{ address: "", addressMarathi: "" }]
    };
  }
};

export default mutations;
